import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Footnote1, Title3 } from '@sbol/nova';
import { Button } from '../../lib/ui/Button';
import MessageCheckmarkImg from './img/message_checkmark.svg?react';
import styles from './ErrorView.module.scss';

export const SurveyAlreadyCompletedErrorView: FC = observer(() => (
  <div className={styles.ErrorView}>
    <MessageCheckmarkImg />
    <Title3 className={styles.Title}>Вы уже прошли опрос</Title3>
    <Footnote1 color="secondary" className={styles.Subtitle}>
      Спасибо за участие! Вы помогаете нам стать лучше
    </Footnote1>
    <Button className={styles.Button} text={import.meta.env.VITE_SBER_LINK_TEXT} href={import.meta.env.VITE_SBER_LINK} isLink />
  </div>
));
